"use client";

import type { WikiDeletionState } from "../wiki-types";
import { Dialog, Button, Alert, Input } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { styles } from "../wiki.styles";

export function WikiPageDeletion({
  deletion,
  mutationError,
  fieldId,
}: Readonly<{
  deletion: WikiDeletionState;
  mutationError: string | null;
  fieldId: string;
}>) {
  return (
    <Dialog
      title="Delete wiki page"
      description="Delete this page and remove it from the wiki?"
      open={deletion.open}
      onOpenChange={(open) => {
        if (!deletion.pending) deletion.onOpenChange(open);
      }}
      trigger={
        <Button size="sm" variant="quiet">
          Delete page
        </Button>
      }
    >
      {mutationError && (
        <Alert tone="danger" announcement="assertive">
          {mutationError}
        </Alert>
      )}
      <form
        onSubmit={(event) => {
          event.preventDefault();

          if (!deletion.pending && deletion.reason.trim()) deletion.onDelete();
        }}
        {...stylex.props(styles.form)}
      >
        <label
          htmlFor={`${fieldId}-delete-reason`}
          {...stylex.props(styles.label)}
        >
          <span {...stylex.props(styles.fieldTitle)}>Reason for deletion</span>
          <Input
            required
            id={`${fieldId}-delete-reason`}
            maxLength={1000}
            value={deletion.reason}
            onChange={(event) => deletion.onReasonChange(event.target.value)}
          />
        </label>
        <div {...stylex.props(styles.actions)}>
          <Button
            type="submit"
            variant="danger"
            disabled={deletion.pending || !deletion.reason.trim()}
          >
            {deletion.pending ? "Deleting…" : "Confirm delete"}
          </Button>
          <Button
            disabled={deletion.pending}
            onClick={() => deletion.onOpenChange(false)}
          >
            Cancel
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
